export default __webpack_public_path__ + "static/media/manja-vitolic-7tOV35hnkao-unsplash.ac70558a.jpg";